import { FC } from 'react';

import clsx from 'clsx';
import {
  Attachment,
  MessageText,
  ReactionsList,
  useChannelStateContext,
  useMessageContext,
  useChannelActionContext,
} from 'stream-chat-react';

import { IconCheckmark } from '@getstream/ui-library/build';

import ShowThreadButton from '../ShowThreadButton';

import styles from './Message.module.css';

export type Props = {};

export const Message: FC<Props> = () => {
  const { message, showDetailedReactions } = useMessageContext();
  const { thread } = useChannelStateContext();
  const { openThread } = useChannelActionContext();

  const isThread = message.id === thread?.id;
  const videoAttachment =
    message.attachments && message.attachments[0]?.type === 'video'
      ? message.attachments[0]
      : undefined;

  return (
    <>
      {/* Reusing default classes */}
      <div
        className={clsx(styles.messageWrapper, {
          [styles.gsThreadInit]: isThread,
        })}
      >
        <div className={styles.messageInner}>
          <div className={styles.gsCustomMessageWrapper}>
            {message.reply_count > 0 && !isThread ? (
              <ShowThreadButton openThread={(e) => openThread(message, e)} />
            ) : null}
            <MessageText customInnerClass={styles.gsCustomMessageInner} />

            {message.latest_reactions &&
              message.latest_reactions.length > 0 && (
                <div className={styles.gsReactions}>
                  <ReactionsList />
                </div>
              )}
          </div>
          {message?.attachments?.length > 0 ? (
            <div
              className={clsx(
                styles.gsCustomMessageAttachment,
                videoAttachment && styles.gsVideoAttachment,
              )}
            >
              {videoAttachment && (
                <a
                  className={styles.gsCustomMessageAttachmentLink}
                  href={videoAttachment.asset_url}
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                >
                  {videoAttachment.asset_url}
                </a>
              )}
              {message.attachments && (
                <Attachment attachments={message.attachments} />
              )}

              <span className={styles.gsCustomMessageAttachmentAuthor}>
                {message.attachments?.[0]?.author_name}
              </span>
            </div>
          ) : null}
          <p className={styles.messageDate}>
            {message.status === 'received' && (
              <IconCheckmark width={16} height={16} />
            )}
            {message.created_at?.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </p>
        </div>
      </div>
    </>
  );
};
